// assets/js/transport.js
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const isEditor = document.body.classList.contains("wp-admin");
if (!isEditor) gsap.registerPlugin(ScrollTrigger);

function toggleItem(item, open) {
  const btn = item.querySelector(".transport__trigger");
  const panel = item.querySelector(".transport__panel");
  if (!btn || !panel) return;

  item.classList.toggle("is-open", open);
  btn.setAttribute("aria-expanded", open ? "true" : "false");

  if (open) {
    panel.hidden = false;
    const h = panel.scrollHeight;

    gsap.fromTo(
      panel,
      { height: 0, opacity: 0 },
      {
        height: h,
        opacity: 1,
        duration: 0.35,
        ease: "power2.out",
        onComplete: () => {
          panel.style.height = "";
        },
      },
    );
  } else {
    gsap.to(panel, {
      height: 0,
      opacity: 0,
      duration: 0.28,
      ease: "power2.inOut",
      onComplete: () => {
        panel.hidden = true;
        panel.style.height = "";
      },
    });
  }
}

function initTransport(section) {
  if (!section || section.__transportInit) return;
  section.__transportInit = true;

  section.querySelectorAll(".transport__item").forEach((item) => {
    const btn = item.querySelector(".transport__trigger");
    const panel = item.querySelector(".transport__panel");
    if (!btn || !panel) return;

    const open = item.classList.contains("is-open");
    panel.hidden = !open;

    btn.addEventListener("click", () => {
      const isOpen = item.classList.contains("is-open");
      toggleItem(item, !isOpen);
    });
  });

  const eyebrow = section.querySelector(".transport__eyebrow");
  const headline = section.querySelector(".transport__headline");
  const topIntro = section.querySelector(".transport__top-intro");
  const left = section.querySelector(".transport__left");
  const photoFig =
    section.querySelector(".transport__photo figure") ||
    section.querySelector(".transport__photo");
  const photoImg = section.querySelector(".transport__photo img");

  gsap.set([eyebrow, headline, topIntro, left], { opacity: 0, y: 18 });
  if (photoFig) gsap.set(photoFig, { opacity: 0, y: 16 });
  if (photoImg) gsap.set(photoImg, { scale: 1.06 });

  const tlOpts = isEditor
    ? { defaults: { ease: "power3.out" } }
    : {
        defaults: { ease: "power3.out" },
        scrollTrigger: { trigger: section, start: "top 78%", once: true },
      };

  const tl = gsap.timeline(tlOpts);
  if (eyebrow) tl.to(eyebrow, { opacity: 1, y: 0, duration: 0.45 });
  if (headline) tl.to(headline, { opacity: 1, y: 0, duration: 0.7 }, "-=0.2");
  if (topIntro) tl.to(topIntro, { opacity: 1, y: 0, duration: 0.5 }, "-=0.3");
  if (left) tl.to(left, { opacity: 1, y: 0, duration: 0.55 }, "-=0.2");

  if (photoFig) {
    tl.to(photoFig, { opacity: 1, y: 0, duration: 0.55 }, "-=0.35");
    if (photoImg)
      tl.to(photoImg, { scale: 1, duration: 0.9, ease: "power2.out" }, "<");
  }

  if (!isEditor && photoFig) {
    gsap.to(photoFig, {
      y: -10,
      ease: "none",
      scrollTrigger: {
        trigger: section,
        start: "top bottom",
        end: "bottom top",
        scrub: 0.4,
      },
    });
  }
}

const mount = () => {
  if (!isEditor) {
    document.querySelectorAll(".transport").forEach(initTransport);
    return;
  }

  const root = document.querySelector(".editor-styles-wrapper") || document;
  const run = () => root.querySelectorAll(".transport").forEach(initTransport);

  run();
  const mo = new MutationObserver(run);
  mo.observe(root, { childList: true, subtree: true });
};

if (window.wp?.domReady) window.wp.domReady(mount);
else document.addEventListener("DOMContentLoaded", mount);
